import {
  POLICY_MANAGEMENT_CLEAR_POLICY,
  POLICY_MANAGEMENT_SET_POLICY,
  policyManagementClearPolicyActionType,
  policyManagementSetPolicyActionType,
  policyManagementSetPolicyFineActionType,
  PolicyManagementThunk,
  SET_POLICY_FINE,
} from './policyManagementActionTypes';
import { CancellationPolicy } from './policyManagementTypes';
import { startLoaderThunk, stopLoaderThunk } from '../modal/modalActions';
import PolicyManagementApi from '../../API/policy-management/PolicyManagement.api';

export function policyManagementSetPolicyAction(
  policy: CancellationPolicy
): policyManagementSetPolicyActionType {
  return {
    type: POLICY_MANAGEMENT_SET_POLICY,
    payload: policy,
  };
}

export function policyManagementClearPolicyAction(): policyManagementClearPolicyActionType {
  return {
    type: POLICY_MANAGEMENT_CLEAR_POLICY,
  };
}

export function policyManagementSetPolicyFineAction(
  fine: number
): policyManagementSetPolicyFineActionType {
  return {
    type: SET_POLICY_FINE,
    payload: fine,
  };
}

export function policyManagementFetchPolicyThunk(
  id: number
): PolicyManagementThunk<Promise<void>> {
  return async (dispatch) => {
    dispatch(startLoaderThunk()).finally();
    PolicyManagementApi.getCancellationPolicyById(id)
      .then((response) => {
        dispatch(policyManagementSetPolicyAction(response.data));
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}
